import {
  FETCH_TOP_BUYERS_REQUEST,
  FETCH_TOP_BUYERS_SUCCESS,
  FETCH_TOP_BUYERS_ERROR,
  FETCH_TOP_BUYERS_SNOWFLAKE_SUCCESS,
} from '../../../actions/widget/ownership'
import { get } from 'lodash'
import { IDLE, FETCHED, FETCHING, FAILED } from '../../../constants/fetchStates'

const initial = {
  holders: [],
  status: IDLE
}

const buyers = (state = initial, action) => {
  switch (action.type) {
    case FETCH_TOP_BUYERS_REQUEST:
      return {
        ...state,
        status: FETCHING
      }
    case FETCH_TOP_BUYERS_SUCCESS:
      let holders = []

      if (action.payload.report) {
        holders = action.payload.report.topBuyers
      } else {
        holders = action.payload
      }
      return {
        ...state,
        holders,
        status: FETCHED
      }
    case FETCH_TOP_BUYERS_SNOWFLAKE_SUCCESS:
      return {
        ...state,
        holders: get(action, 'payload.data.mover.items', []),
        status: FETCHED
      }
    case FETCH_TOP_BUYERS_ERROR:
      return {
        ...state,
        error: action.error,
        status: FAILED
      }
    default:
      return state
  }
}

export default buyers
